import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/common.css';

const VendorEdit = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const item = state?.item;

  const [OrderID, setOrderID] = useState(item?.C6_OrderID || '');
  const [licenseCount, setLicenseCount] = useState(item?.A2_LicenseCount || '');
  const [licenseStartDate, setLicenseStartDate] = useState(item?.A3_LicenseStartDate || '');
  const [endDate, setEndDate] = useState(item?.A4_LicenseEndDate || '');


  const handleSubmit = async (e) => {
    e.preventDefault();

    const isOrderIDChanged = OrderID !== (item.C6_OrderID || '');
    const isCountChanged = Number(licenseCount) !== Number(item.A2_LicenseCount);
    const isEndDateChanged = endDate !== item.A4_LicenseEndDate;
    const isStartDateChanged = licenseStartDate !== item.A3_LicenseStartDate;

    if (!isOrderIDChanged && !isCountChanged && !isEndDateChanged && !isStartDateChanged) {
      alert("変更内容がありません。ライセンス数、終了日、または開始日を変更してください。");
      return;

    } else if (!isEndDateChanged && isStartDateChanged) {
      alert("開始日を変更する場合は終了日も変更してください。");
      return;
    }

    const payload = {
      CustomerEmail: item.CustomerEmail,
      LicenseKey: item.LicenseKey,
      UpdatedLicenseCount: licenseCount,
      UpdatedEndDate: endDate,
      UpdatedStartDate: licenseStartDate,
      OrderID: OrderID
    };

    try {
      const res = await fetch("https://pfnhd6mixj.execute-api.ap-northeast-1.amazonaws.com/UpdateLicenseStage/update_license", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (data.message === "success") {
        navigate('/license/success');
      } else {
        alert('送信に失敗しました');
      }
    } catch (err) {
      console.error("送信エラー:", err);
      alert("サーバーエラーが発生しました");
    }
  };

  return (
    <div className="container">
      <h2 className="title">変更申請</h2>
      <form onSubmit={handleSubmit} className="form-wrapper">
        {item.D3_Trial === "トライアル" && (
          <div className="form-group">
            <label>発注番号</label><br />
            <input
              type="text"
              value={OrderID}
              onChange={(e) => {
                const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                setOrderID(value);
              }}
              className="fixed-input"
            />
            <span className="label-note">※トライアルから移行する場合のみ</span>
          </div>
        )}

        <div className="form-group">
          <label>ライセンス数</label><br />
          <input
            type="number"
            value={licenseCount}
            min="1"
            max="99"
            onChange={(e) => setLicenseCount(e.target.value)}
            required
            className="fixed-input"
          />
          <span className="label-note">変更前の数：{item.A2_LicenseCount}</span>
        </div>

        {item.D3_Trial === "トライアル" && (
          <div className="form-group">
            <label>本契約開始日</label><br />
            <input
              type="date"
              value={licenseStartDate}
              onChange={(e) => setLicenseStartDate(e.target.value)}
              className="fixed-input"
            />
            <span className="label-note">※トライアルから移行する場合のみ</span>
          </div>
        )}

        <div className="form-group">
          <label>ライセンス終了日</label><br />
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              required
              className="fixed-input"
            />
            <span className="label-note">変更前の終了日：{item.A4_LicenseEndDate}</span>
        </div>

        <div className="button-group">
          <button type="button" className="button button-gray button-fixed" onClick={() => navigate(-1)}>戻る</button>
          <button type="submit" className="button button-blue button-fixed">申請</button>
        </div>
      </form>
    </div>
  );
};

export default VendorEdit;
